<script setup>
const props = defineProps({
  ambiti: {
    type: Array,
    default: () => [],
  },
})
const ambitiRef = ref(props.ambiti)

const half = computed(() => Math.ceil(ambitiRef.value.length / 2))

const firstHalf = computed(() => ambitiRef.value.slice(0, half.value))
const secondHalf = computed(() => ambitiRef.value.slice(half.value))
</script>

<template>
  <div class="adda-trasformazione row-400-20 p-top-7 max">
    <div class="blocks-container">
      <!-- eslint-disable vue/no-v-html -->
      <h2 class="heading-1 title m-bot-1">
        Con il metodo ADDA accompagniamo ogni funzione aziendale nel percorso di
        trasformazione digitale
      </h2>
      <div class="ambiti-container">
        <div class="column-1">
          <div
            v-for="(ambito, index) in firstHalf"
            :key="'first-half-' + index"
            class="ambito"
          >
            <div class="first-level">
              <p class="text-4 ambito-title" v-html="ambito.titolo" />
              <p
                v-if="ambito.testo"
                class="text-4 ambito-introtext"
                v-html="ambito.testo"
              />
            </div>
          </div>
        </div>
        <div class="column-2">
          <div
            v-for="(ambito, index) in secondHalf"
            :key="'second-half-' + index"
            class="ambito"
          >
            <div class="first-level">
              <div class="text-4 ambito-title" v-html="ambito.titolo" />
              <div
                v-if="ambito.testo"
                class="text-4 ambito-introtext"
                v-html="ambito.testo"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddaTrasformazione',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
